export enum EnumAgrupamentoItensVenda {
    LancarSeparadamente,
    AgruparSomenteMesmoValor
}